const articles = [
  {
    id: 1,
    title: "The Rise of Student AI Creators",
    preview: "How everyday students are using machine intelligence to build, create, and innovate like never before.",
    content: "Full article content goes here...",
    image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=800&h=600&fit=crop",
  },
  {
    id: 2,
    title: "Inside the Future of Automation",
    preview: "Automation is no longer futuristic… it's already shaping classrooms and creativity.",
    content: "Full article content goes here...",
    image: "https://images.unsplash.com/photo-1441716844725-09cedc13a4e7?w=800&h=600&fit=crop",
  },
];

// auto-generate up to 15 articles
const imageUrls = [
  "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1496346651079-6ca5cb67f42f?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1483721310020-03333e577078?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=600&fit=crop",
];


for (let i = 3; i <= 15; i++) {
  articles.push({
    id: i,
    title: `Untitled AI Insight ${i}`,
    preview: "A short preview of the article goes here...",
    content: "Full article content goes here...",
    image: imageUrls[(i - 3) % imageUrls.length],
  });
}

export default articles;
